import { render } from "./TravelPreferencesAssignment.vue?vue&type=template&id=40b4ffb6"
import script from "./TravelPreferencesAssignment.vue?vue&type=script&lang=js"
export * from "./TravelPreferencesAssignment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__